/* eslint-disable react/button-has-type */
/** @jsx jsx */
import React, { useEffect, useState, useCallback } from 'react';
import ReactDOM from 'react-dom';
import { css, jsx } from '@emotion/core';
import { grayScale, textFontSize, utilityColor } from 'components/styles';
import FlexBoxItem from 'components/atoms/FlexBoxItem';
import FlexBox from 'components/atoms/FlexBox';
import useComponentVisible from 'hooks/useComponentVisible';
import Icon from 'components/atoms/Icon';
import BodyText from 'components/atoms/BodyText';
import ContextMenuBox from './ContextMenuBox';
import { ContextMenuType } from './type';

const { innerWidth: width } = window;

const style = {
  contextMenu: css`
    border-radius: 3px;
    > div {
      background-color: white;
    }
  `,
};
const baseButtonStyle = css({
  display: 'flex',
  justifyContent: 'space-between',
  padding: '8px 14px',
  fontSize: textFontSize.re,
  width: width * 0.18,
  border: '1px solid #DCDCDC',
  borderRadius: '3px',
  backgroundColor: '#F2F2F2',
});

const SelectContextMenu: React.FC<{
  text: string;
  buttons: ContextMenuType[]
  disable: boolean
}> = ({
  text,
  buttons,
  disable,
}) => {
  const {
    ref,
    isComponentVisible,
    setIsComponentVisible,
  } = useComponentVisible(false);

  const bodyNode = document.querySelector('body') as HTMLBodyElement;
  const [parentEle, setParentEle] = useState<HTMLElement | null>(null);

  useEffect(() => {
    setParentEle(ref.current);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleClickMenu = useCallback(() => {
    // if (belongOrgFix && belongOrgFix === '1') {
    //   return;
    // }

    setIsComponentVisible(!isComponentVisible);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ref]);

  return (
    <FlexBox
      customStyle={css({
        justifyContent: 'center',
      })}
    >
      <FlexBoxItem width="100%">
        <div ref={ref}>
          <button css={disable ? baseButtonStyle : css(baseButtonStyle, { backgroundColor: utilityColor.white })} onClick={handleClickMenu} disabled={disable}>
            <BodyText color={grayScale.gray100}>{text}</BodyText>
            <Icon type="dropdown" color={grayScale.gray60} />
          </button>

          {ReactDOM.createPortal(
            <div className="contextMenu" css={style.contextMenu}>
              <ContextMenuBox
                items={buttons}
                isVisible={isComponentVisible}
                setIsComponentVisible={setIsComponentVisible}
                parentEle={parentEle}
                parentRef={ref}
                minWidth={`${width * 0.18}px`}
                minusLeft={width * 0.18}
              />
            </div>,
            bodyNode,
          )}
        </div>
      </FlexBoxItem>
    </FlexBox>
  );
};

export default SelectContextMenu;
